"use client";

import { type ReactNode } from "react";

import { TemplateExecutionProvider } from "src/contexts/TemplateExecutionContext";
import { useExecuteTemplateOnMount } from "src/hooks/useExecuteTemplateOnMount";

const TemplateExecutionContent = ({ children }: { children: ReactNode }) => {
  useExecuteTemplateOnMount();
  return <>{children}</>;
};

export const TemplateExecutionWrapper = ({
  children,
}: {
  children: ReactNode;
}) => {
  return (
    <TemplateExecutionProvider>
      <TemplateExecutionContent>{children}</TemplateExecutionContent>
    </TemplateExecutionProvider>
  );
};
